module.exports = __webpack_public_path__ + "img/pylon.9d51cf0e.png";